<div class="wrapper">
  <span class="error">Error 404</span>
  <span class="title">Page not found!</span>
  <span class="description">The page you're looking for can't be found.</span>
  <button mat-raised-button color="primary" routerLink="">Go Home</button>
</div>
